import React from "react";

const Contact = () => {
    return (
        <section className="section bg-purple-300">Contact</section>
    );
}

export default Contact;